import { createContext, useContext, ReactNode } from 'react';
import { SubmissionDetailTab } from './index';
import { SubmissionDetailReviewTab } from 'src/components/Submission/BoardMemberReviewsTab';
import { IBackofficeTab } from 'src/components/Submission/BackofficeTab/BackofficeTab';
import { IIntegrityTab } from 'src/components/Submission/IntegrityTab';
interface SubmissionDetailsContextProps {
  activeTab: SubmissionDetailTab;
  setActiveTab: (tab: SubmissionDetailTab) => void;
  backOfficeSubTab: IBackofficeTab;
  setBackOfficeSubTab: (tab: IBackofficeTab) => void;
  reviewsSubTab: SubmissionDetailReviewTab;
  setReviewsSubTab: (tab: SubmissionDetailReviewTab) => void;
  integritySubTab: IIntegrityTab;
  setBackIntegritySubTab: (tab: IIntegrityTab) => void;
}

const SubmissionDetailsContext = createContext<
  SubmissionDetailsContextProps | undefined
>(undefined);

export const SubmissionDetailsProvider = ({
  children,
  activeTab,
  reviewsSubTab,
  backOfficeSubTab,
  setActiveTab,
  setReviewsSubTab,
  setBackOfficeSubTab,
  integritySubTab,
  setBackIntegritySubTab
}: {
  children: ReactNode;
  activeTab: SubmissionDetailTab;
  backOfficeSubTab: IBackofficeTab;
  reviewsSubTab: SubmissionDetailReviewTab;
  setActiveTab: (tab: SubmissionDetailTab) => void;
  setReviewsSubTab: (tab: SubmissionDetailReviewTab) => void;
  setBackOfficeSubTab: (tab: IBackofficeTab) => void;
  integritySubTab: IIntegrityTab;
  setBackIntegritySubTab: (tab: IIntegrityTab) => void;
}) => {
  return (
    <SubmissionDetailsContext.Provider
      value={{
        activeTab,
        reviewsSubTab,
        backOfficeSubTab,
        setActiveTab,
        setReviewsSubTab,
        setBackOfficeSubTab,
        integritySubTab,
        setBackIntegritySubTab
      }}
    >
      {children}
    </SubmissionDetailsContext.Provider>
  );
};

export const useSubmissionDetails = () => {
  const context = useContext(SubmissionDetailsContext);
  if (!context) {
    throw new Error(
      'useSubmissionDetails must be used within an SubmissionDetailsProvider'
    );
  }
  return context;
};
